export default (function (_ref) {
  var request = _ref.request;
  return {
    breedSegmentAdd: function breedSegmentAdd(data) {
      return request({
        url: '/cms/breedSegment/add',
        method: 'post',
        data: data
      });
    },
    breedSegmentModify: function breedSegmentModify(data) {
      return request({
        url: "/cms/breedSegment/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedSegmentDel: function breedSegmentDel(id) {
      return request({
        url: "/cms/breedSegment/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedSegmentQuery: function breedSegmentQuery(data) {
      return request({
        url: '/cms/breedSegment',
        method: 'get',
        params: data
      });
    },
    breedSegmentDetail: function breedSegmentDetail(id) {
      return request({
        url: "/cms/breedSegment/".concat(id),
        method: 'get'
      });
    }
  };
});